import './NavigationBar.css';
import { Link, useLocation } from 'react-router-dom';

const NavigationBar = () => {

	const location = useLocation();
	const { pathname } = location;

	// helper do aktywnej klasy
	const isActive = (pathPart) => {
		if (pathname === '/') return false; 
		return pathname.includes(pathPart);
	};

	return (
		<div id='NavigationBarMainContainer'>
			<div id='NavButtonsContainer'>
				<Link
					to='/aktualnosci'
					className={`NavigationLink ${isActive('aktualnosci') ? 'active' : ''}`}
				>
					Aktualności
				</Link>

				<Link
					to='/misja'
					className={`NavigationLink ${isActive('misja') ? 'active' : ''}`}
				>
					Misja
				</Link>

				<Link
					to='/trenerzy'
					className={`NavigationLink ${isActive('trenerzy') ? 'active' : ''}`}
				>
					Trenerzy
				</Link>

				<Link
					to='/kontakt'
					className={`NavigationLink ${isActive('kontakt') ? 'active' : ''}`}
				>
					Kontakt
				</Link>
			</div>
		</div>
	);
};

export default NavigationBar;
